import {
  MFA_SELECTOR_TOTP_DESCRIPTION,
  MFA_SELECTOR_WEB_AUTHN_DESCRIPTION,
  MFA_TOTP_NAME,
  MFA_WEB_AUTHN_NAME,
} from './ui.labels'

export const RECOVERY_OTP = 'RECOVERY_OTP'
export const TOTP = 'TOTP'
export const WEB_AUTHN = 'WEB_AUTHN'

export const MFATypes = {
  TOTP,
  WEB_AUTHN,
}

export const AvailableMFA = {
  [WEB_AUTHN]: {
    name: MFA_WEB_AUTHN_NAME,
    icon: 'security_key',
    color: 'blue',
    description: MFA_SELECTOR_WEB_AUTHN_DESCRIPTION,
  },
  [TOTP]: {
    name: MFA_TOTP_NAME,
    icon: 'phonelink_lock',
    color: 'green',
    description: MFA_SELECTOR_TOTP_DESCRIPTION,
  },
}
